import { RentalsReservationInstance } from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import { FleetCategoryAvailabilityEnum } from '@jucy/rentals-api-client';

export const isOnRequestReservation = (reservation?: Partial<RentalsReservationInstance>) => {
    if (!reservation) {
        return false;
    }

    return 'fleetCategory' in reservation && reservation.fleetCategory?.availability === FleetCategoryAvailabilityEnum.OnRequest;
};
